import { Box, Card, Grid, Typography } from '@mui/material';

import { formatCurrency } from '@/shared';

export type TotalAmountRubroServicioCardProps = {
  calcSubTotal: () => string;
  calcTotal: () => string;
  calcTaxesButIvaLine: () => string;
};

const TotalAmountRubroServicioCard: React.FC<
  TotalAmountRubroServicioCardProps
> = ({ calcSubTotal, calcTotal, calcTaxesButIvaLine }) => {
  return (
    <Grid item xs={12}>
      <Card
        // variant="outlined"
        sx={{ px: 2, py: 4, borderRadius: 1, marginTop: 2 }}
      >
        {/* --------- subtotal & taxes --------- */}
        <Grid item container xs={12} px={2}>
          <Grid item md={8}>
            <Grid container>
              {/* ---- subtotal ---- */}
              <Grid
                item
                md={2}
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography align="center">SUBTOTAL</Typography>
                <Typography align="center">
                  {formatCurrency(calcSubTotal())}
                </Typography>
              </Grid>
              {/* ---- + ---- */}
              <Grid
                item
                md={1}
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography align="center" variant="h4">
                  +
                </Typography>
              </Grid>
              {/* ---- taxes ---- */}
              <Grid
                item
                md={2}
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography align="center">IMPUESTO</Typography>
                <Typography align="center">
                  {formatCurrency(calcTaxesButIvaLine())}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* --------- total --------- */}
          <Grid
            item
            md={4}
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Box p={1}>
              <Typography align="center" variant="h5">
                <span className="total_subtitle_invoice">TOTAL: </span>

                {formatCurrency(calcTotal())}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

export default TotalAmountRubroServicioCard;
